import React from "react";
import Flex from "@irati/ui/src/Flex";
import zipLogo from "@irati-web/payments/src/images/zip-logo.svg";
import zipHeart from "@irati-web/payments/src/images/zip-modal-heart.svg";
import zipCart from "@irati-web/payments/src/images/zip-modal-cart.svg";
import zipThumbUp from "@irati-web/payments/src/images/zip-modal-thumb-up.svg";
import FormattedMessage from "@irati/utils/lang";
import { Body } from "@irati/ui/src/Typography";
import { Row, Col } from "react-bootstrap";
import tracking from "@irati-tracking/perks/perks";
import { ZipLogoModal, ZipH3, ZipModalImage, ZipBody, ZipH2, ZipModalButtonLink } from "./styled";
var ZipModalContent = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(ZipLogoModal, { src: zipLogo }),
        React.createElement(Flex, { justifyContent: "center" },
            React.createElement(ZipH2, null,
                React.createElement(FormattedMessage, { id: "platform.payments.zip.modalTitle" }))),
        React.createElement(Body, { textAlign: "center", small: true },
            React.createElement(FormattedMessage, { id: "platform.payments.zip.modalSubtitle" }),
            "."),
        React.createElement(Row, null,
            React.createElement(Col, { md: 4 },
                React.createElement(Flex, { justifyContent: "space-around" },
                    React.createElement(ZipModalImage, { src: zipHeart })),
                React.createElement(ZipH3, null,
                    React.createElement(FormattedMessage, { id: "platform.payments.zip.wantit.header" })),
                React.createElement(ZipBody, null,
                    React.createElement(FormattedMessage, { id: "platform.payments.zip.wantit.body" }))),
            React.createElement(Col, { md: 4 },
                React.createElement(Flex, { justifyContent: "space-around" },
                    React.createElement(ZipModalImage, { src: zipCart })),
                React.createElement(ZipH3, null,
                    React.createElement(FormattedMessage, { id: "platform.payments.zip.getit.header" })),
                React.createElement(ZipBody, null,
                    React.createElement(FormattedMessage, { id: "platform.payments.zip.getit.body" }))),
            React.createElement(Col, { md: 4 },
                React.createElement(Flex, { justifyContent: "space-around" },
                    React.createElement(ZipModalImage, { src: zipThumbUp })),
                React.createElement(ZipH3, null,
                    React.createElement(FormattedMessage, { id: "platform.payments.zip.ownit.header" })),
                React.createElement(ZipBody, null,
                    React.createElement(FormattedMessage, { id: "platform.payments.zip.ownit.body" })))),
        React.createElement(Flex, { justifyContent: "center" },
            React.createElement(ZipModalButtonLink, { primary: true, target: "_blank", href: "https://zip.co/uk/how-it-works/", onClick: tracking.moreAboutZip },
                React.createElement(FormattedMessage, { id: "platform.payments.zip.moreAboutZip" })))));
};
export default ZipModalContent;
